import { cx } from "@suse-o11y/class-variance";
import React from "react";

import { Label } from "~/components/label";

import styles from "./_switch.module.css";

export interface SwitchLabelProps extends React.ComponentProps<typeof Label> {
	children: React.ReactNode;
}

export const SwitchLabel = React.forwardRef<React.ElementRef<typeof Label>, SwitchLabelProps>(
	({ className, ...props }, ref) => <Label className={cx(styles.label, className)} ref={ref} {...props} />,
);

if (import.meta.env.DEV) {
	SwitchLabel.displayName = "SwitchLabel";
}
